'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validate = undefined;

var _SimpleValid = require('./SimpleValid');

Object.defineProperty(exports, 'Validate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimpleValid).default;
  }
});

var _rules = require('./rules');

var _rules2 = _interopRequireDefault(_rules);

var _messages = require('./messages');

var _messages2 = _interopRequireDefault(_messages);

var _SimpleValid2 = _interopRequireDefault(_SimpleValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SimpleValid2.default(_rules2.default, _messages2.default);